import { render } from "./ActorList.vue?vue&type=template&id=fc16648e&scoped=true&lang=pug"
import script from "./ActorList.vue?vue&type=script&lang=js"
export * from "./ActorList.vue?vue&type=script&lang=js"

import "./ActorList.vue?vue&type=style&index=0&id=fc16648e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc16648e"]])

export default __exports__